import cx from "classnames"
import { camelize } from "../../utils"
import type { IconColorsType } from "../"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "invoice"
const InvoiceIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`c-fill-${camelize(color || "")}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    },
  )
  return (
    <span className={computedClassName}>
      {
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
          <title>{iconSource}</title>
          <path d="M13.5 15.75C13.914 15.75 14.25 16.086 14.25 16.5S13.914 17.25 13.5 17.25H7.5C7.086 17.25 6.75 16.914 6.75 16.5S7.086 15.75 7.5 15.75zM16.5 12.75C16.914 12.75 17.25 13.086 17.25 13.5S16.914 14.25 16.5 14.25H7.5C7.086 14.25 6.75 13.914 6.75 13.5S7.086 12.75 7.5 12.75zM10.378 4.5C11.289 4.5 12.024 4.922 12.536 5.597L11.634 6.337C11.336 5.898 10.908 5.626 10.397 5.626 9.764 5.625 9.233 5.991 8.945 6.609H11.131V7.641H8.666C8.656 7.716 8.657 7.8 8.657 7.875 8.657 7.959 8.657 8.035 8.666 8.109H11.131V9.141H8.927C9.187 9.759 9.746 10.125 10.397 10.125 11.02 10.125 11.513 9.787 11.82 9.272L12.75 9.975C12.201 10.735 11.466 11.25 10.397 11.25 9.039 11.25 8.006 10.406 7.587 9.14H6.75V8.11H7.401V7.64H6.75V6.61H7.597C8.015 5.371 9.047 4.5 10.377 4.5" />
          <path
            fillRule="evenodd"
            d="M18.75 1.5C19.578 1.5 20.25 2.172 20.25 3V20.425C20.25 21.591 18.978 22.312 17.978 21.712L15.75 20.375 12.772 22.162C12.297 22.447 11.703 22.447 11.228 22.162L8.25 20.375 6.022 21.712C5.022 22.312 3.75 21.59 3.75 20.425V3C3.75 2.172 4.422 1.5 5.25 1.5zM5.25 20.425 7.478 19.088C7.953 18.803 8.547 18.803 9.022 19.088L12 20.875 14.978 19.089C15.453 18.803 16.047 18.803 16.522 19.088L18.75 20.425V3H5.25z"
            clipRule="evenodd"
          />
        </svg>
      }
    </span>
  )
}
export default InvoiceIcon
